import {
  SPONSOR_ALL,
  SPONSOR_GET,
  SPONSOR_DEL,
  SPONSOR_PUT,
  SPONSOR_POST,
  SPONSOR_LOADING,
  SPONSOR_ERROR,
} from '../../actions/types';

const initialState = {
  sponsor: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case SPONSOR_LOADING:
      return { isLoading: true, isCompleted: true };
    case SPONSOR_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case SPONSOR_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SPONSOR_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SPONSOR_POST:
      return { isLoading: false, isCompleted: true };
    case SPONSOR_PUT:
      return { isLoading: false, isCompleted: true };
    case SPONSOR_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
